import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getDrivingData,
  saveDrivingConfiguration,
  getDrivingConfiguration
} from "../../modules/driving";
import { changeSelectedTags } from "../../modules/units";
import { setStartDate, setEndDate } from "../../modules/dates";
import { changeTitle } from "../../modules/navigation";
import { formatDateString } from "./../../utilities/datesFormatter";
import hasTP from "./../../utilities/unitsFilters";
import { getDefaultDrivingConfiguration } from "./../../utilities/driving";
import DrivingView from "./DrivingView";
import { DOMAIN } from "../../utilities/consts";

class Driving extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivingConfiguration: getDefaultDrivingConfiguration(),
      isConfigOpen: false,
      alertMessage: "",
      isAlertMessageOpen: false,
      selectedTrips: [],
      selectedTripsReport: {},
      isAllTripsSelected: false
    };
  }

  componentDidMount = () => {
    const {
      getDrivingConfiguration,
      configuration,
      changeTitle,
      changeSelectedTags
    } = this.props;
    changeTitle("Driving");
    changeSelectedTags([]);
    getDrivingConfiguration()
      .then(() => {
        this.setState({ drivingConfiguration: configuration });
      })
      .catch(err => {
        this.openAlertMessage(
          this.props.lang.ErrorAlCargarConfiguracionDriving
        );
      });
  };

  fetchDrivingData = () => {
    const config = {
      fechaInicial: this.props.startDate.valueOf(),
      fechaFinal: this.props.endDate.valueOf(),
      unidades: this.props.selectedUnits,
      unidadDistancia: this.props.distanceUnit,
      zona: this.props.zone
    };

    if (config.unidades.length === 0) {
      this.openAlertMessage(this.props.lang.SeleccioneAlMenosUnaUnidad);
      return;
    }

    this.props.getDrivingData(config).catch(err => {
      this.openAlertMessage(this.props.lang.ErrorAlConsultarDatos);
    });
  };

  onBlurInputConfiguration = e => {
    let value = e.target.value;
    const id = e.target.id;
    let config = Object.assign({}, this.state.drivingConfiguration);

    if (value === "") {
      config[id] = 0;
      value = this.setState({
        drivingConfiguration: config
      });
    }
  };

  handleInputsConfiguration = e => {
    e.preventDefault();
    const id = e.target.id;
    let value = e.target.value;
    let config = Object.assign({}, this.state.drivingConfiguration);

    if (id !== "LimiteCGU") {
      value = parseInt(value, 10) % 10;
      if (value > 5) value = 5;
      else if (value < 0) value = 0;
    }

    config[id] = value;
    this.setState({
      drivingConfiguration: config
    });
  };

  openConfiguration = () => {
    this.setState({ isConfigOpen: true });
  };

  closeConfiguration = () => {
    this.setState({ isConfigOpen: false });
  };

  saveConfiguration = () => {
    let config = this.state.drivingConfiguration;
    this.setState({ isConfigOpen: false });
    this.props
      .saveDrivingConfiguration(config)
      .then(() => {
        this.openAlertMessage(this.props.lang.ConfiguracionGuardada);
      })
      .catch(err => {
        this.openAlertMessage(this.props.lang.ErrorAlGuardarConfiguracion);
      })
      .finally(() => {
        this.setState({ drivingConfiguration: this.props.configuration });
      });
  };

  resetConfigurationValues = () => {
    this.setState({
      drivingConfiguration: this.props.configuration
    });
  };

  defaultConfigurationValues = () => {
    this.setState({
      drivingConfiguration: getDefaultDrivingConfiguration()
    });
  };

  openAlertMessage = message => {
    this.setState({
      isAlertMessageOpen: true,
      alertMessage: message
    });
  };

  handleCloseAlertMessage = () => {
    this.setState({
      isAlertMessageOpen: false,
      message: ""
    });
  };

  generalBehaviorClassSelector = () => {
    const validUnits = this.props.analysisByUnit.filter(u => u.Trayectos > 0);
    let cguLimit = this.props.configuration.LimiteCGU * validUnits.length;

    if (cguLimit === 0) cguLimit = 1;

    const relation = this.props.generalReport.ComportamientoGeneral / cguLimit;

    if (relation >= 0 && relation < 0.5) return "green-card";
    else if (relation > 0.5 && relation < 1) return "yellow-card";
    else if (relation >= 1) return "red-card";
    else return "";
  };

  toggleSelectionTrips = (key, shift, row) => {
    let selectedTrips = [...this.state.selectedTrips];
    const keyIndex = selectedTrips.indexOf(key);
    if (keyIndex >= 0) {
      selectedTrips = [
        ...selectedTrips.slice(0, keyIndex),
        ...selectedTrips.slice(keyIndex + 1)
      ];
    } else {
      selectedTrips.push(key);
    }
    this.setState({
      selectedTrips,
      selectedTripsReport: this.calculateTripsReport(selectedTrips)
    });
  };

  toggleAllSelectedTrips = () => {
    const isAllSelected = this.state.isAllTripsSelected;
    if (isAllSelected)
      this.setState({
        selectedTrips: [],
        isAllTripsSelected: !isAllSelected,
        selectedTripsReport: this.props.generalReport
      });
    else
      this.setState({
        selectedTrips: this.props.trips.map(t => t._id),
        isAllTripsSelected: !isAllSelected,
        selectedTripsReport: this.props.generalReport
      });
  };

  isSelectedTrip = key => {
    return this.state.selectedTrips.includes(key);
  };

  calculateTripsReport = selectedTripsKeys => {
    let selectedTrips = this.props.trips.filter(
      trip => selectedTripsKeys.filter(t => trip._id === t).length > 0
    );

    let selectedTripsReport = {
      ExcesoVelocidad: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.ExcesoVelocidad + acum,
        0
      ),
      AceleracionIntensa: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.AceleracionIntensa + acum,
        0
      ),
      FrenadoIntenso: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.FrenadoIntenso + acum,
        0
      ),
      GiroBrusco: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.GiroBrusco + acum,
        0
      ),
      CurvaPeligrosa: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.CurvaPeligrosa + acum,
        0
      ),
      Impacto: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.Impacto + acum,
        0
      ),
      Colision: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.Colision + acum,
        0
      ),
      Ralenti: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.Ralenti + acum,
        0
      ),
      Desgaste: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.Desgaste + acum,
        0
      ),
      Riesgo: selectedTrips.reduce(
        (acum, t) => t.ReporteTrayecto.Riesgo + acum,
        0
      ),
      DistanciaRecorrida: selectedTrips.reduce(
        (acum, t) => t.DistanciaRecorrida + acum,
        0
      )
    };

    selectedTripsReport.ComportamientoGeneral =
      selectedTripsReport.Desgaste + selectedTripsReport.Riesgo;

    selectedTripsReport.VelocidadMaxima = Math.max(
      ...selectedTrips.map(t => t.ReporteTrayecto.VelocidadMaxima)
    );

    return selectedTripsReport;
  };

  downloadExcel = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.reportUnits,
      unidadDistancia = this.props.distanceUnit,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=driving&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}&unidadDistancia=${unidadDistancia}`,
      "_blank"
    );
  };

  downloadPDF = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.reportUnits,
      unidadDistancia = this.props.distanceUnit,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=drivingPDF&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}&unidadDistancia=${unidadDistancia}`,
      "_blank"
    );
  };

  render() {
    if (this.props.loadedPermissions && !this.props.permissions.Driving) {
      return <Redirect to={"./"} push />;
    }
    return (
      <DrivingView
        {...this.props}
        drivingConfiguration={this.state.drivingConfiguration}
        isConfigOpen={this.state.isConfigOpen}
        fetchDrivingData={this.fetchDrivingData}
        canEdit={this.props.permissions.EdicionDriving}
        handleInputsConfiguration={this.handleInputsConfiguration}
        openConfiguration={this.openConfiguration}
        closeConfiguration={this.closeConfiguration}
        saveConfiguration={this.saveConfiguration}
        resetConfigurationValues={this.resetConfigurationValues}
        defaultConfigurationValues={this.defaultConfigurationValues}
        alertMessage={this.state.alertMessage}
        isAlertMessageOpen={this.state.isAlertMessageOpen}
        handleCloseAlertMessage={this.handleCloseAlertMessage}
        downloadExcel={this.downloadExcel}
        downloadPDF={this.downloadPDF}
        onBlurInputConfiguration={this.onBlurInputConfiguration}
        generalBehaviorClassSelector={this.generalBehaviorClassSelector}
        selectedTrips={this.state.selectedTrips}
        toggleSelectionTrips={this.toggleSelectionTrips}
        toggleAllSelectedTrips={this.toggleAllSelectedTrips}
        isSelectedTrip={this.isSelectedTrip}
        isAllTripsSelected={this.state.isAllTripsSelected}
        selectedTripsReport={this.state.selectedTripsReport}
        generalReport={
          this.state.selectedTrips.length > 0
            ? this.state.selectedTripsReport
            : this.props.generalReport
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let units = state.units.data.filter(unit => hasTP(unit, [".db"]));

  const selectedTags = state.units.selectedTags;
  if (selectedTags.length > 0)
    units = units.filter(unit => {
      let unitTags = unit.Etiquetas.split(",").filter(t => t !== "");
      return (
        unitTags.filter(ut => {
          return selectedTags.includes(ut);
        }).length > 0
      );
    });

  const trips = state.driving.data.Trayectos.map((trip, i) => ({
    _id: i + 1,
    Trayecto: i + 1,
    Unidad: state.units.data.filter(u => u.Unidad === trip.Unidad)[0]
      .Descripcion,
    Inicio: trip.FechaInicial,
    Fin: trip.FechaFinal,
    Impacto: trip.NumeroEventos.Impacto > 0,
    Colision: trip.NumeroEventos.Colision > 0,
    Puntos: trip.ReporteTrayecto.ComportamientoGeneral,
    DistanciaRecorrida: trip.ReporteTrayecto.DistanciaRecorrida,
    ReporteTrayecto: trip.ReporteTrayecto,
    UbicacionInicio: trip.Eventos[0],
    UbicacionFin: trip.Eventos[trip.Eventos.length - 1]
  }));

  let events = state.driving.data.Trayectos.reduce((arrayEvents, trip) => {
    trip.Eventos.forEach(e => (e.Unidad = trip.Unidad));
    return arrayEvents.concat(trip.Eventos);
  }, []).map(e => ({
    ImagenUrl: `../images/${e.Evento}.svg`,
    NombreEvento: state.internationalization.lang[`Event${e.Evento}`],
    Unidad: state.units.data.filter(u => u.Unidad === e.Unidad)[0].Descripcion,
    FechaEvento: formatDateString(e.Fecha),
    Puntos: e.Puntos,
    Detalle: e.Detalle,
    Mapa: state.internationalization.lang.Mapa,
    Latitud: e.Latitud,
    Longitud: e.Longitud
  }));

  let requestedUnits = [];
  if (state.driving.hasData) {
    requestedUnits = state.driving.data.Unidades;
  }

  let analysisByUnit = [];
  if (state.driving.hasData) {
    analysisByUnit = requestedUnits.map(unit => {
      let trips = state.driving.data.Trayectos.filter(
        trip => trip.Unidad === unit
      );

      return {
        Descripcion: state.units.data.filter(u => u.Unidad === unit)[0]
          .Descripcion,
        ExcesosVelocidad: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.ExcesoVelocidad,
          0
        ),
        AceleracionesIntensas: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.AceleracionIntensa,
          0
        ),
        FrenadosIntensos: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.FrenadoIntenso,
          0
        ),
        GirosBruscos: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.GiroBrusco,
          0
        ),
        Impactos: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.Impacto,
          0
        ),
        Colisiones: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.Colision,
          0
        ),
        Ralenties: trips.reduce(
          (sum, trip) => sum + trip.NumeroEventos.Ralenti,
          0
        ),
        Trayectos: trips.length,
        DistanciaRecorrida: `${trips.reduce(
          (sum, trip) => sum + trip.ReporteTrayecto.DistanciaRecorrida,
          0
        )} ${state.driving.data.UnidadDistancia}`,
        Puntos: trips.reduce(
          (sum, trip) => sum + trip.ReporteTrayecto.Puntos,
          0
        )
      };
    });
  }
  return {
    units,
    selectedTrips: state.driving.selectedTrips,
    selectedUnits: state.units.selectedUnits,
    reportUnits: state.driving.data.Unidades,
    firstLocationDate: state.driving.data.FechaPrimeraUbicacion,
    lastLocationDate: state.driving.data.FechaUltimaUbicacion,
    startDate: state.dates.startDate,
    endDate: state.dates.endDate,
    zone: state.dates.zone,
    distanceUnit: state.driving.data.UnidadDistancia,
    generalReport: state.driving.data.ReporteGeneral,
    analysisByUnit,
    configuration: state.driving.configuration.data,
    hasData: state.driving.hasData,
    lang: state.internationalization.lang,
    drivingEvents: [...events],
    trips,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    isLoading:
      state.driving.isLoading ||
      state.driving.configuration.isLoading ||
      state.units.isLoading
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDrivingConfiguration,
      getDrivingData,
      saveDrivingConfiguration,
      setStartDate,
      setEndDate,
      changeTitle,
      changeSelectedTags
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Driving);



// WEBPACK FOOTER //
// ./src/containers/Driving/Driving.js